module.exports = __webpack_public_path__ + "static/media/27445.35647240.jpg";